// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';
import { setStorage } from "src/lib/storage";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { Link } from 'src/modules/link/jsx/component.jsx';
import { validURL } from "src/lib/utils";

// Stateful components
export class HelpfulLinks extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "helpful_links": null,
            "student_links": null,
            "helpful_links_is_active": false,
            "student_links_is_active": false,
            "modal_add_link_is_active": false,
            "modal_edit_link_is_active": false,
            "manage_link_name": "",
            "manage_link_url": "",
            "form_error": false,
            "form_error_message": null,
            "modal_titles": {
                "base": "Manage my links",
                "add": "Add a new link",
                "edit": "Edit link",
                "saved": "Link saved",
                "listing": "Edit my links"
            },
            "modal_edit_data": null
        };

        // Binds
        this.toggleQuickLinks = this.toggleQuickLinks.bind(this);
        this.toggleStudentLinks = this.toggleStudentLinks.bind(this);
        
        this.handleLinkManagerName = this.handleLinkManagerName.bind(this);
        this.handleLinkManagerUrl = this.handleLinkManagerUrl.bind(this);
        this.submitNewLink = this.submitNewLink.bind(this);
        this.editLink = this.editLink.bind(this);
        this.deleteLink = this.deleteLink.bind(this);
        this.updateLink = this.updateLink.bind(this);

        this.RenderModalAddLinkContent = this.RenderModalAddLinkContent.bind(this);
        this.RenderModalEditLinkListingContent = this.RenderModalEditLinkListingContent.bind(this);
        this.RenderModalEditLinkContent = this.RenderModalEditLinkContent.bind(this);
        this.RenderModalBaseContent = this.RenderModalBaseContent.bind(this);
        this.RenderModalLinkSaved = this.RenderModalLinkSaved.bind(this);
        this.RenderHelpfulLinks = this.RenderHelpfulLinks.bind(this);
        this.RenderStudentLinks = this.RenderStudentLinks.bind(this);
        this.RenderEditableStudentLinks = this.RenderEditableStudentLinks.bind(this);

        this.RenderModal = this.RenderModal.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        var portal_context = this_component['context'];

        var user_personalisation = portal_context['user_personalisation'];

        // get helpful links from data
        var helpful_links = portal_context['configuration']['portal_links']['quickLinks'];
        // run personalisation check over data
        helpful_links = sq_personalise.fn.filterItems(helpful_links, user_personalisation['attributes']);
        if(helpful_links.length == 0){
            helpful_links = null;
        }

        // get custom student links
        var student_links = squiz.fn.getStorage('getallstorage', 'session', 'json');
        // refine the data down
        student_links = student_links['data']['quicklinks'];
        // make sure we have custom student links
        if(typeof student_links == 'undefined' || student_links.length == 0){
            student_links = null;
        }
        
        this_component.setState({
            "helpful_links": helpful_links,
            "student_links": student_links,
            //"student_links": null
        });

    }

    //
    // Events
    //

    toggleQuickLinks(event){
        event.preventDefault();
        var this_component = this;

        this_component.setState(prevState => ({
            "helpful_links_is_active": !prevState['helpful_links_is_active'],
            "student_links_is_active": false
        }));
    }
    toggleStudentLinks(event){
        event.preventDefault();
        var this_component = this;

        this_component.setState(prevState => ({
            "student_links_is_active": !prevState['student_links_is_active'],
            "helpful_links_is_active": false
        }));
    }


    handleLinkManagerName(event){
        var this_component = this;
        this_component.setState({
            "manage_link_name": event.target.value
        });
    };
    handleLinkManagerUrl(event){
        var this_component = this;
        this_component.setState({
            "manage_link_url": event.target.value
        });
    };


    editLink(event, item, index){
        event.preventDefault();
        // set itemn and index to state
        var this_component = this;
        this_component.setState({
            "modal_edit_data": {
                "item": item,
                "item_index": index
            },
            "manage_link_name": item['name'],
            "manage_link_url": item['target_url']
        }, function(){
            this_component.RenderModal('edit');
        });
    };

    //
    // Functions
    //

    checkForDynamicLinks(links_list) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        links_list.forEach(function(link, link_index) {
            if(typeof(link['url_asset_id']) !== 'undefined') {
                link['url'] = helpers.getDynamicLinkUrlById(link['url_asset_id']);
            } else {
                link['url'] = helpers.getDynamicLinkURL(link['url']);
            }
        });

        return links_list;
    }

    submitNewLink(event){
        event.preventDefault();
        var this_component = this;

        var new_link_name = this_component['state']['manage_link_name'];
        var new_link_url = this_component['state']['manage_link_url'];

        var linkIsValid = validURL(new_link_url);

        // if submit shows empty input fields
        // return error
        if(new_link_name.length == 0 || new_link_url.length == 0 || !linkIsValid){
            
            this_component.setState({
                "form_error": true,
                "form_error_message": "Errors on page"
            }, function(){
                this_component.RenderModal('add');
            });
            
        } else {

            var new_link = {
                "name": new_link_name,
                "target_url": new_link_url
            };

            // get existing custom student links (if any)
            var storage_data = squiz.fn.getStorage('getallstorage', 'session', 'json');
            // refine the data down
            
            // make sure we have custom student links (quicklinks), if not, add it in
            if(typeof storage_data['data']['quicklinks'] == 'undefined'){
                storage_data['data']['quicklinks'] = [];
            }
            storage_data['data']['quicklinks'].push(new_link);

            this_component.setLinkStorage(storage_data);
            
            this_component.setState({
                "student_links": storage_data['data']['quicklinks'],
                "form_error": false,
                "manage_link_name": null,
                "manage_link_url": null
            }, function(){
                // show a 'done' screen
                this_component.RenderModal('saved');
                setTimeout(function(){ 
                    // then, load the base screen
                    this_component.RenderModal('listing');
                }, 1000);
            }); 
        }

    }

    setLinkStorage(storage_data){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        // store back to session
        var storage_key = squiz['vars']['store_id'] + 'getallstorage';
        setStorage('session', storage_key, storage_data);

        var gatekeeper_options = {
            "source": "setallstorage,1",
            "data": storage_data['data']['quicklinks'],
            "success": function(response){
                
            },
            "startsWithParam": "quicklinks"
        };
        //
        // write back to gatekeeper API
        //
        helpers.setGatekeeperData(gatekeeper_options);
    };

    deleteLink(){
        var this_component = this;

        var student_links = this_component['state']['student_links'];
        var editable_link_content = this_component['state']['modal_edit_data'];
        var remove_index = editable_link_content['item_index'];
        student_links.splice(remove_index, 1);
        

        // get existing custom student links (if any)
        var storage_data = squiz.fn.getStorage('getallstorage', 'session', 'json');
        // refine the data down
        
        storage_data['data']['quicklinks'] = student_links;

        this_component.setLinkStorage(storage_data);


        this_component.setState({
            "student_links": student_links,
            "form_error": false,
            "manage_link_name": null,
            "manage_link_url": null
        }, function(){
            // show a 'done' screen
            this_component.RenderModal('saved');
            setTimeout(function(){ 
                // then, load the base screen
                this_component.RenderModal('listing');
            }, 1000);
        });

    }

    updateLink(){
        var this_component = this;

        var student_links = this_component['state']['student_links'];
        var editable_link_content = this_component['state']['modal_edit_data'];
        var update_index = editable_link_content['item_index'];

        var updated_link_name = this_component['state']['manage_link_name'];
        var updated_link_url = this_component['state']['manage_link_url'];
        
        student_links[update_index]['name'] = updated_link_name;
        student_links[update_index]['target_url'] = updated_link_url;

        // get existing custom student links (if any)
        var storage_data = squiz.fn.getStorage('getallstorage', 'session', 'json');
        // refine the data down
        
        storage_data['data']['quicklinks'] = student_links;

        this_component.setLinkStorage(storage_data);


        this_component.setState({
            "student_links": student_links,
            "form_error": false,
            "manage_link_name": null,
            "manage_link_url": null
        }, function(){
            // show a 'done' screen
            this_component.RenderModal('saved');
            setTimeout(function(){ 
                // then, load the base screen
                this_component.RenderModal('listing');
            }, 1000);
        });

    }



    //
    // Render
    //
    RenderModal(modal_type){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        
        var modal_titles = this_component['state']['modal_titles'];
        var modal_content = null;
        var modal_title = null;

        if(modal_type == 'add'){
            modal_content = this_component.RenderModalAddLinkContent();
            modal_title = modal_titles['add'];
        } else if(modal_type == 'listing'){
            modal_content = this_component.RenderModalEditLinkListingContent();
            modal_title = modal_titles['listing'];
        } else if(modal_type == 'saved'){
            modal_content = this_component.RenderModalLinkSaved();
            modal_title = modal_titles['saved'];
        } else if(modal_type == 'edit') {
            modal_content = this_component.RenderModalEditLinkContent();
            modal_title = modal_titles['edit'];
        } else {
                modal_content = this_component.RenderModalBaseContent();
                modal_title = modal_titles['base'];
        }
        
        var modal_buttons = this_component.renderModalButtons();

        // Get modal data
        var modal_data = {
            'title': modal_title,
            'class': 'modal-student-links',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
    };

    RenderModalAddLinkContent(){
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];

        var errors = this_component['state']['form_error'];
        var error_message = this_component['state']['form_error_message'];

        var name = this_component['state']['manage_link_name'];
        var url = this_component['state']['manage_link_url'];

        var url_help_text = null;
        if (configuration['portal_links'] && configuration['portal_links']['url_help']) {
            url_help_text = <span className="my-links-editor__help">{configuration['portal_links']['url_help']}</span>;
        }

        return (
            <>
            <form className="my-links-editor" onSubmit={this_component['submitNewLink']}>
                {errors && 
                    <p className="form-errors">{error_message}</p>
                }
                <div className="my-links-editor__text">
                    <label htmlFor="add-link__name">
                        Name of link
                    </label>
                    <input type="text" defaultValue={name} id="add-link__name" name="name" onChange={this_component['handleLinkManagerName']} required />
                </div>
                <div className="my-links-editor__text">
                    <label htmlFor="add-link__target_url">
                        URL
                    </label>
                    <input type="url" pattern="https?://.+" defaultValue={url} id="add-link__target_url" name="target_url" onChange={this_component['handleLinkManagerUrl']} required />
                    {url_help_text}
                </div>

                <button type="submit" className="btn btn-secondary">Add to My links</button>
            </form>
            
            <div className="student-links__button-wrapper">
                <div className="student-links__section student-links__edit">
                    <button className="btn btn-primary" onClick={() => this_component.RenderModal('listing')}>Back to Edit my links</button>
                </div>
            </div>
                        
            </>
        );
    };
    RenderModalEditLinkListingContent(){
        var this_component = this;
        return (
            <>
            
            <this_component.RenderEditableStudentLinks/>
            
            <div className="student-links__button-wrapper">
                <div className="student-links__section student-links__add">
                    <button className="btn btn-primary" onClick={() => this_component.RenderModal('add')}>Add a new link</button>
                </div>
            </div>

            </>
        );
    };
    RenderModalEditLinkContent(){
        var this_component = this;
        var errors = this_component['state']['form_error'];
        var error_message = this_component['state']['form_error_message'];

        var editable_link_content = this_component['state']['modal_edit_data'];
        var editable_link_name = editable_link_content['item']['name'];
        var editable_link_url = editable_link_content['item']['target_url'];

        return (
            <>
            <form className="my-links-editor" onSubmit={this_component['updateLink']}>
                {errors && 
                    <p className="form-errors">{error_message}</p>
                }
                <div className="my-links-editor__text">
                    <label htmlFor="add-link__name">
                        Name of link
                    </label>
                    <input type="text" defaultValue={editable_link_name} id="add-link__name" name="name" onChange={this_component['handleLinkManagerName']} required />
                </div>
                <div className="my-links-editor__text">
                    <label htmlFor="add-link__target_url">
                        URL
                    </label>
                <input type="url" pattern="https?://.+" defaultValue={editable_link_url} id="add-link__target_url" name="target_url" onChange={this_component['handleLinkManagerUrl']} required />
                </div>

                <button type="submit" className="btn btn-secondary">Save changes</button>
                
            </form>
            
            <div className="student-links__button-wrapper">
                <div className="student-links__section student-links__edit">
                    <button className="btn btn-primary" onClick={this_component['deleteLink']}>Delete this link</button>
                </div>
                <div className="student-links__section student-links__edit">
                    <button className="btn btn-primary" onClick={() => this_component.RenderModal('listing')}>Back to Edit my links</button>
                </div>
            </div>
                        
            </>
        );
    }
    RenderModalBaseContent(){
        var this_component = this;
        return (
            <>
                <div className="student-links__button-wrapper">
                    <div className="student-links__section student-links__add">
                        <button className="btn btn-primary" onClick={() => this_component.RenderModal('add')}>Add a new link</button>
                    </div>
                    <div className="student-links__section student-links__edit">
                        <button className="btn btn-primary" onClick={() => this_component.RenderModal('listing')}>Edit my links</button>
                    </div>
                </div>
            </>
        );
    };
    RenderModalLinkSaved(){
        var this_component = this;
        return (
            <>
               <div className="student-links__content-saved">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"  width="52" height="52">
                    <path fill="#9c0e02" d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M40.495,17.329l-16,18
                        C24.101,35.772,23.552,36,22.999,36c-0.439,0-0.88-0.144-1.249-0.438l-10-8c-0.862-0.689-1.002-1.948-0.312-2.811
                        c0.689-0.863,1.949-1.003,2.811-0.313l8.517,6.813l14.739-16.581c0.732-0.826,1.998-0.9,2.823-0.166
                        C41.154,15.239,41.229,16.503,40.495,17.329z"/>
                </svg>
               </div>
            </>
        );
    }


    renderModalButtons() {
        return (
            [{
                'class': 'btn btn-secondary',
                'label': 'Cancel and close',
                'clickHandler': null,
                'action': 'close'
            }]
        );
    }

    RenderHelpfulLinks(){
        var this_component = this;
        var helpful_links = this_component['state']['helpful_links'];

        var links_list = 
            <li className="helpful-links__inner-list__item">
                <p className="no-result">No links found.</p>
            </li>;

        if(helpful_links) {
            var updated_links = this_component.checkForDynamicLinks(helpful_links);

            links_list = updated_links.map(function(link, link_index){
                var link_data = {
                    'url': link['url'],
                    'class': 'helpful-links__inner-list__link',
                    'label': link['name']
                };

                return (
                    <li className="helpful-links__inner-list__item" key={link_index}>
                        <Link data={link_data} />
                    </li>
                )
            });
        }

        return (
            <ul className="helpful-links__inner-list helpful-links__inner-list--open">
                {links_list}
            </ul>
        );

    }

    RenderStudentLinks(){
        var this_component = this;
        var student_links = this_component['state']['student_links'];
        return (
            <>
                <ul className="helpful-links__inner-list helpful-links__custom-links helpful-links__inner-list--open">
                    {student_links ? (
                        <>
                        {student_links.map((item, index) =>(
                            <li className="helpful-links__inner-list__item" key={index}>
                                <a href={item['target_url']} className="helpful-links__inner-list__link">
                                    {item['name']}
                                </a>
                            </li>
                        ))}
                        <li className="helpful-links__inner-list__item no-result">
                            <button className="helpful-links__inner-list__edit-button" onClick={() => this_component.RenderModal('base')}>
                                <span>Edit links</span>
                                <span className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                    <path
                                        d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z" />
                                    <path
                                        d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z" />
                                </svg>
                                </span>
                            </button>
                        </li>
                        </>
                    ) : (
                        <>
                        <li className="helpful-links__inner-list__item no-result">
                            <p>No links found.</p>
                            <button className="helpful-links__inner-list__edit-button" onClick={() => this_component.RenderModal('base')}>
                                <span>Edit links</span>
                                <span className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                    <path
                                        d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z" />
                                    <path
                                        d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z" />
                                </svg>
                                </span>
                            </button>
                        </li>
                        </>
                    )}
                </ul>
            </>
        );

    }

    RenderEditableStudentLinks(){
        var this_component = this;
        var student_links = this_component['state']['student_links'];
        return (
            <>
                <ul className="editable-student-links">
                    {student_links ? (
                        <>
                        {student_links.map((item, index) =>(
                            <li className="editable-student-links__item" key={index}>
                                <a href="#" className="editable-student-links__link" onClick={(event) => this_component.editLink(event, item, index)}>
                                    {item['name']}
                                    <span className="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                        <path
                                            d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z" />
                                        <path
                                            d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z" />
                                    </svg>
                                    </span>
                                </a>
                            </li>
                        ))}
                        </>
                    ) : (
                        <>
                        <li className="editable-student-links__item no-result">
                            <p>No current links to show.</p>
                        </li>
                        </>
                    )}
                </ul>
            </>
        );

    }

    render() {
        var this_component = this;
        var is_quick_links_active = this_component['state']['helpful_links_is_active'];
        var is_student_links_active = this_component['state']['student_links_is_active'];

        
        return (
            <>
            <div className="helpful-links__wrapper">
                <ContextualMessage id="quick_links" />
                <ul className="helpful-links__list">
                    <li className="helpful-links__item" data-ga-label="Quick links">
                        <button className={is_quick_links_active ? 'helpful-links__toggle helpful-links__toggle--open' : 'helpful-links__toggle'} onClick={this_component['toggleQuickLinks']}>
                            Quick links
                        </button>
                        {is_quick_links_active && 
                            <this_component.RenderHelpfulLinks />
                        }
                    </li>
                    <li className="helpful-links__item" data-ga-label="My links">
                        <button className={is_student_links_active ? 'helpful-links__toggle helpful-links__toggle--open' : 'helpful-links__toggle'} onClick={this_component['toggleStudentLinks']}>
                            My links
                        </button>
                        {is_student_links_active && 
                            <this_component.RenderStudentLinks />
                        }
                    </li>
                </ul>
            </div>
           </>
        );
    }

};

HelpfulLinks.contextType = PortalContext;
